<template>
  <FileTable v-if="isAdmin" ref="fileTable" />
</template>

<script>
import FileTable from "@/components/Dashboard/Views/ChatbotManagement/ChatbotManagement.vue";
import store from "@/store/store";
export default {
  components: {
    FileTable,
  },
  computed: {
    isAdmin() {
      const user = store.state.auth.user;
      return user && user.role === "admin";
    }
  },
  mounted() {
    if (!this.isAdmin) {
      this.$router.push("/overview");
    }
  },
  methods: {
    refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Optional: spacing and styling for button */
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChatbotManagement/index.vue